"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isArray = exports.isArray = Array.isArray || function (x) {
  return x && typeof x.length === 'number';
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.4/util/isArray.js
// module id = 148
// module chunks = 171